export default {
    title: 'ห้องรอ',

    menu: {
        starDraw: 'สุ่มดาว',
        seedLetter: 'ตัวอักษรเมล็ดพันธุ์',
        task: 'การบ้าน',
        typing: 'ศึกพิมพ์ดีด',
        recentResult: {
            label: 'ผลคาบเรียนล่าสุด',
            short: 'ผลคาบเรียน<br/>ล่าสุด',
        },
    },

    studentInfo: {
        gradeFormat: 'ชั้นปีที่ {grade}',
        logoutConfirm: {
            title: 'ออกจากระบบ',
            message: 'ต้องการออกจากระบบไหม?',
        },
    },

    navigation: {
        toAvatars: 'ไปที่สุ่มดาว',
        toSeedLetter: 'ไปที่ตัวอักษรเมล็ดพันธุ์',
        toRecentResult: 'ไปที่ผลคาบเรียนล่าสุด',
    },

    languageSetting: {
        menuLabel: 'ตั้งค่าภาษา',
        title: 'ตั้งค่าภาษา',
        description: 'สามารถเลือกภาษาที่ช่วยเหลือบนหน้าจอการเรียนได้',
    },
};
